var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.414 17.414"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(1 1.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_30",
    d: "M0 9.6L9.6 0",
    className: "cls-1",
    "data-name": "Line 30",
    transform: "translate(5.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    d: "M13 1h3v3",
    className: "cls-1",
    "data-name": "Path 61",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    d: "M13 10v4.8a1.155 1.155 0 0 1-1.2 1.2H2.2A1.155 1.155 0 0 1 1 14.8V5.2A1.155 1.155 0 0 1 2.2 4H7",
    className: "cls-2",
    "data-name": "Path 62",
    transform: "translate(-1 -1)"
  }))));
}
export default __webpack_public_path__ + "static/media/ic_out.04dcf11d.svg";
export { SvgIcOut as ReactComponent };